/**
 * @generated SignedSource<<6f888e0583caca5f02a6c56005d84f71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpaceContextCard_space$data = {
  readonly color: {
    readonly dark: string;
    readonly light: string;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceIndicator_space">;
  readonly " $fragmentType": "SpaceContextCard_space";
};
export type SpaceContextCard_space$key = {
  readonly " $data"?: SpaceContextCard_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceContextCard_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpaceContextCard_space",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SpaceIndicator_space"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Color",
      "kind": "LinkedField",
      "name": "color",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "light",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dark",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Space",
  "abstractKey": null
};

(node as any).hash = "33419fa1b21a2398aa38e55e653d7da9";

export default node;
